import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import style from './NotificationsForCategory.module.scss';

const NotificationsForCategory: React.FC = () => {
	const { notificationsForCategory } = useContext<IDishAssignmentContext>(DishAssignmentContext);

	const notificationClasses = classNames(style.hiddenSection, {
		[style.visible]: notificationsForCategory === 'showNotification',
	});
	const loadingClasses = classNames(style.hiddenSection, {
		[style.visible]: notificationsForCategory === 'showLoading',
	});

	return (
		<div className={style.container} data-test="NotificationsForCategory">
			<div className={notificationClasses}>
				<Text
					translationNameSpace="listing"
					translationKey="createCategoryHint"
					theme="secondaryLight"
					size="l"
					align="center"
					components={[
						<Link key="1" to="/menu/category/create">
							Categories
						</Link>,
					]}
				/>
			</div>
			<Text className={loadingClasses} translationNameSpace="listing" translationKey="loadingLabel" />
		</div>
	);
};

export default NotificationsForCategory;
